export default from './ResultColumnHeadTextFormElement'


// WEBPACK FOOTER //
// ./src/components/search/FormElements/ResultColumnHeadTextFormElement/index.js